import { Option } from '@/Atomic/Molecules/Inputs/Select/types'
import { SimpleSelect } from '@/Atomic/Molecules/SimpleSelect'
import { SchemaAttributes } from '@/Data/types'
import { getSchemaName } from '@/utils/dataClassMap'
import { getSchema } from '@/utils/getSchema'
import { getLocalizedSchemaAttributes } from '@/utils/schemaLocalization'

interface FilterSelectProps {
  dataClassName: string
  filterKey: string
  value: string | null
  setValue: (newVal: string | null) => void
  allOptionLabel: string
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
  dataClassName,
  filterKey,
  value,
  setValue,
  allOptionLabel,
}) => {
  const { schema } = getSchema(getSchemaName(dataClassName))

  if (!schema) return null

  const schemaAttributes = getLocalizedSchemaAttributes(
    schema?.get('attributes') as SchemaAttributes,
  )

  const filterValues = schemaAttributes?.[filterKey]?.enumValues

  if (!filterValues) return null

  const options: Option[] = [
    { label: allOptionLabel || 'All', value: 'all' },
    ...filterValues.map((filter) => ({
      label: filter.title,
      value: filter.value,
    })),
  ]

  const currentValue = value || 'all'
  const selectedOption = options.find((o) => o.value === currentValue)

  const handleChange = (newValue: Option) => {
    const val = newValue.value as string
    if (val === 'all') {
      setValue(null)
    } else {
      setValue(val)
    }
  }

  return (
    <SimpleSelect
      name={`${filterKey}-select`}
      options={options}
      value={selectedOption}
      onChange={handleChange}
    />
  )
}
